import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6ece51ee&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6ece51ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ece51ee",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsLink: require('/opt/build/repo/components/Elements/Link.vue').default,ElementsSlider: require('/opt/build/repo/components/Elements/Slider.vue').default})
